import { Nillable } from '@web/utils';
import { jsonMember, jsonObject } from 'typedjson';
import {
  DictionaryCountryResponse,
  PhoneNumberWithPrefixResponse,
} from '@web/shared/module/dictionary';

@jsonObject
export class PublicCartBillingAddressResponse {
  @jsonMember(String)
  public readonly firstName?: Nillable<string>;

  @jsonMember(String)
  public readonly lastName?: Nillable<string>;

  @jsonMember(PhoneNumberWithPrefixResponse)
  public readonly phone?: Nillable<PhoneNumberWithPrefixResponse>;

  @jsonMember(String)
  public readonly email?: Nillable<string>;

  @jsonMember(String)
  public readonly streetLine1?: Nillable<string>;

  @jsonMember(String)
  public readonly streetLine2?: Nillable<string>;

  @jsonMember(String)
  public readonly postCode?: Nillable<string>;

  @jsonMember(String)
  public readonly city?: Nillable<string>;

  @jsonMember(String)
  public readonly state?: Nillable<string>;

  @jsonMember(String)
  public readonly companyName?: Nillable<string>;

  @jsonMember(String)
  public readonly companyNip?: Nillable<string>;

  @jsonMember(DictionaryCountryResponse)
  public readonly country?: Nillable<DictionaryCountryResponse>;
}
